import { PromotionCategoryType } from "@comparaonline/offers-models-constants";
import { Coupon, PaymentMethod } from "@comparaonline/cicl-funnel-schema";
import { Offer } from "@comparaonline/offers-models";

const removeDiscount = (offer: Offer): Offer => {
  const {
    product: { mainAttribute }
  } = offer;

  return {
    ...offer,
    product: {
      ...offer.product,
      mainAttribute: {
        ...mainAttribute,
        value: {
          ...mainAttribute.value,
          amount: mainAttribute.value.previousTotal
        }
      }
    }
  };
};

const removeProductAttributePromotion = (offer: Offer): Offer => {
  const [...productAttributes] = offer.product.productAttributes;
  const paIndex = productAttributes.findIndex(pa =>
    [PromotionCategoryType.FREE_INSTALLMENTS, PromotionCategoryType.GIFT].includes(
      pa.entity.code as PromotionCategoryType
    )
  );

  if (paIndex) {
    productAttributes.splice(paIndex, 1);
  }

  return {
    ...offer,
    product: {
      ...offer.product,
      productAttributes
    }
  };
};

const isValidPromotionByPaymentMethod = (
  promotion: Coupon,
  paymentMethod: PaymentMethod
): boolean => {
  if (!promotion || !promotion.paymentMethods) return false;
  if (!promotion.paymentMethods.length) return true;

  return promotion.paymentMethods
    .map(({ name }) => (name === PaymentMethod.Pat ? PaymentMethod.PatCreditCard : name))
    .includes(paymentMethod);
};

export const removePromotionByPaymentMethod = (
  paymentMethod: PaymentMethod,
  offer?: Offer
): Offer | undefined => {
  if (
    !offer ||
    !offer.promotion ||
    !offer.promotion.code ||
    isValidPromotionByPaymentMethod(offer.promotion, paymentMethod)
  ) {
    return offer;
  }

  const { promotion } = offer;

  switch (promotion.category.code) {
    case PromotionCategoryType.FREE_INSTALLMENTS:
    case PromotionCategoryType.GIFT:
      return removeProductAttributePromotion(offer);
    case PromotionCategoryType.DISCOUNT:
      return removeDiscount(offer);
  }
};
